export const consts = {
  /** 全部展示 */
  DISPLAY_ALL: 1,
  /** 部分展示 */
  DISPLAY_PARTIAL: 2,
  /** 不展示 */
  DISPLAY_NONE: 3,
}

export const opts = {
  /** 列表展示状态（短文案） */
  displayStatusMaps: [
    {value: consts.DISPLAY_ALL, label: '全部展示'},
    {value: consts.DISPLAY_PARTIAL, label: '部分展示'},
    {value: consts.DISPLAY_NONE, label: '不展示'},
  ],
  /** 表单单选（完整文案） */
  displayFormMaps: [
    {value: consts.DISPLAY_ALL, label: '展示，所有用户可见'},
    {value: consts.DISPLAY_PARTIAL, label: '展示，部分用户可见'},
    {value: consts.DISPLAY_NONE, label: '不展示任务包'},
  ],
}

export function getOptionLabel (options, value) {
  const item = (options || []).find(option => Number(option.value) === Number(value))
  return item ? item.label : ''
}

export function getDisplayStatusLabel (display) {
  return getOptionLabel(opts.displayStatusMaps, display) || '不展示'
}

export function getDisplayFormLabel (display) {
  return getOptionLabel(opts.displayFormMaps, display) || '不展示任务包'
}

export function getDisplayStatusTagType (display) {
  switch (Number(display)) {
    case consts.DISPLAY_ALL:
      return 'success'
    case consts.DISPLAY_PARTIAL:
      return 'warning'
    case consts.DISPLAY_NONE:
      return 'info'
    default:
      return 'info'
  }
}

export function isDisplayEnabled (display) {
  const value = Number(display)
  return value === consts.DISPLAY_ALL || value === consts.DISPLAY_PARTIAL
}

export function isDisplayPartial (display) {
  return Number(display) === consts.DISPLAY_PARTIAL
}



// WEBPACK FOOTER //
// ./src/views/project-task-package/project-task-package.constants.js